import { Fragment } from 'react'

import { Breadcrumb, BreadcrumbWrapper, Link, StyledSeparator } from './styles'
import { BreadcrumbsProps, Route } from './type'

export const Separator = ({
  color = 'white',
  heightClass = 'regular'
}: Pick<BreadcrumbsProps, 'color' | 'heightClass'>) => (
  <StyledSeparator color={color} heightClass={heightClass}>
    |
  </StyledSeparator>
)

const Breadcrumbs = ({
  routes,
  heightClass = 'regular',
  color = 'white',
  linkWrapper
}: BreadcrumbsProps) => {
  const isLastRoute = (index: number) => routes.length - 1 === index

  const RenderBreadcrumb = ({ description, url }: Route, index: number) => {
    if (linkWrapper) {
      return linkWrapper({
        url,
        children: (
          <Breadcrumb
            active={isLastRoute(index)}
            color={color}
            key={index}
            heightClass={heightClass}
          >
            {description}
          </Breadcrumb>
        )
      })
    }

    return (
      <Link href={url}>
        <Breadcrumb
          active={isLastRoute(index)}
          color={color}
          key={index}
          heightClass={heightClass}
        >
          {description}
        </Breadcrumb>
      </Link>
    )
  }

  return (
    <BreadcrumbWrapper>
      {routes.map((route, index) => (
        <Fragment key={index}>
          {RenderBreadcrumb(route, index)}
          {!isLastRoute(index) && (
            <Separator color={color} heightClass={heightClass} />
          )}
        </Fragment>
      ))}
    </BreadcrumbWrapper>
  )
}

export default Breadcrumbs
